import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { of, throwError, concat } from 'rxjs';
import { map, tap, retry, delayWhen, retryWhen, concatMap, delay, take } from 'rxjs/operators';
import { Helper } from '../pages/common/helper';

@Injectable({
  providedIn: 'root'
})
export class DailyLogsService {

  constructor(private http: HttpClient) { }

  createDailyLogs(form: string, action: string, result: string, systemRemarks: string, mainTableName: string, mainTableKey: string, userID: number) {

    // convert to httpPost
    let paramObject = {
      'form': form,
      'action': action,
      'result': result,
      'systemRemarks': systemRemarks,
      'mainTableName': mainTableName,
      'mainTableKey': mainTableKey,
    }

    return this.http.post(Helper.API_URL() + '/api/security/CreateDailyLogs', paramObject);

  }

}
